import React, { useContext } from 'react';
import { Dialog, Button, DialogContent, Typography, DialogTitle, IconButton } from '@material-ui/core';
import { I18nContext } from 'translations';
import CloseIcon from '@material-ui/icons/Close';
import BoxIcon from 'components/Icons/Box';
import WhatsappIcon from 'components/Icons/Whatsapp';
import AndroidIcon from '@material-ui/icons/Android';
import AppleIcon from '@material-ui/icons/Apple';

export default function ModalMessageBlockB2C ({
  openMessageBlockB2C,
  setOpenMessageBlockB2C,
}) {
  const { translate } = useContext(I18nContext);

  const close = () => setOpenMessageBlockB2C(false);

  return (
    <Dialog
      open={openMessageBlockB2C}
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
      style={{ zIndex: '9000'}}
    >
       <DialogTitle>
        <IconButton
          aria-label="close"
          onClick={close} style={{ position: 'absolute', right: 0 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="text-center" style={{ padding: '40px 55px 50px' }}>
        <BoxIcon />
        <Typography variant="body1" color="primary" style={{ margin: '20px 0' }}>
          <b>{translate('app.modalMessageBlock.text')}.</b>
        </Typography>
        <Button
          href="https://play.google.com/store/apps/details?id=co.picap.passenger&hl=es_CO"
          style={{ marginRight: '10px' }}
          target="_blank"
          variant="outlined"
          className="btn-rounded"
          size="small"
          startIcon={<AndroidIcon />}
        >
          {translate('landing.footer.playStore')}
        </Button>
        <Button
          href="https://apps.apple.com/co/app/picap/id1139476429"
          target="_blank"
          variant="outlined"
          className="btn-rounded"
          size="small"
          startIcon={<AppleIcon />}
        >
          {translate('landing.footer.appStore')}
        </Button>

        <Typography variant="body1" style={{ margin: '25px 0 35px' }}>
          {translate('app.modalMessageBlock.text2')}, <b>{translate('app.modalMessageBlock.text3')}</b>
        </Typography>
        <Button
          href="https://wa.me/3107872609"
          size="medium"
          target="_blank"
          variant="contained"
          style={{ background: 'linear-gradient(180deg, #EE44EB 0%, #842AD2 100%)', borderRadius: '60px', color: '#fff' }}
        >
          <u style={{ marginRight: '9px' }}>
            {translate('app.modalMessageBlock.btn')}
          </u>
          <WhatsappIcon />
        </Button>
      </DialogContent>
    </Dialog>
  )
}